import { AbstractControl, ControlValueAccessor, NgControl } from '@angular/forms';
import { Component, OnInit, Optional, Self, Output, EventEmitter, Input, Inject } from '@angular/core';
import { Country, CountryQuery, CountryService, DEFAULT_COUNTRY } from '@fgb/core';

@Component({
  selector: 'fgbcl-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss']
})
export class SelectCountryComponent implements OnInit, ControlValueAccessor {

  control: AbstractControl | any;
  onChangeCallback = (_: any) => {};
  onTouchedCallback = () => {};
  innerValue: string = '';
  @Input() label: string;
  @Output() countryChange: EventEmitter<Country> = new EventEmitter();

  constructor(@Inject(DEFAULT_COUNTRY) private defaultCountry: string, @Optional() @Self() private ngControl: NgControl,
              private countryService: CountryService, 
              private countryQuery: CountryQuery) { 
    if( this.ngControl ) this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    if( this.ngControl ){
      this.control = this.ngControl.control;
      this.control.updateValueAndValidity();
    } 
    
    this.countryService.fetchCountries().toPromise().then(()=> {
      if( this.ngControl ){
        // Set the default value if the control is not set
        const value = this.innerValue || this.defaultCountry;
        // Update to emit the country change event
        this.writeValue(value);
      }
    });

  }

  writeValue(value: string): void {
    this.innerValue = value;
    this.onChangeCallback(this.innerValue);
    const country = this.countries.find(country => country.CountryName === value);
    setTimeout(() => this.countryChange.emit(country));
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  get countries(){
    return this.countryQuery.getAll().sort(this._sort());
  }

  private _sort(){
    return (a: any, b: any) => {
      if (a.Ordinal < b.Ordinal) {
        return -1;
      } else if (a.Ordinal > b.Ordinal) { 
          return 1;
      } else if (a.Ordinal === b.Ordinal) {
        return a.DisplayName.localeCompare(b.DisplayName);
      }
      return 0;
    }
  }

}
